export default {
  DRAFT_SELL: 'ni-coins',
  DRAFT_BUY_SELL_SHARES: 'ni-coins',
  DRAFT_CAPITAL_INCREASE: 'ni-trend-up',
  DRAFT_CONVERTIBLE_NOTE: 'ni-invest',
};
